/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Price } from './Price';
import {
    PriceFromJSON,
    PriceFromJSONTyped,
    PriceToJSON,
} from './Price';

/**
 * Representation of a Delivery mode
 * @export
 * @interface DeliveryMode
 */
export interface DeliveryMode {
    /**
     * Code of the delivery mode
     * @type {string}
     * @memberof DeliveryMode
     */
    code?: string;
    /**
     * Name of the delivery mode
     * @type {string}
     * @memberof DeliveryMode
     */
    name?: string;
    /**
     * Description of the delivery mode
     * @type {string}
     * @memberof DeliveryMode
     */
    description?: string;
    /**
     * 
     * @type {Price}
     * @memberof DeliveryMode
     */
    deliveryCost?: Price;
    /**
     * 
     * @type {boolean}
     * @memberof DeliveryMode
     */
    isDefault?: boolean;
}

/**
 * Check if a given object implements the DeliveryMode interface.
 */
export function instanceOfDeliveryMode(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DeliveryModeFromJSON(json: any): DeliveryMode {
    return DeliveryModeFromJSONTyped(json, false);
}

export function DeliveryModeFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeliveryMode {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': !exists(json, 'code') ? undefined : json['code'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'deliveryCost': !exists(json, 'deliveryCost') ? undefined : PriceFromJSON(json['deliveryCost']),
        'isDefault': !exists(json, 'isDefault') ? undefined : json['isDefault'],
    };
}

export function DeliveryModeToJSON(value?: DeliveryMode | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'name': value.name,
        'description': value.description,
        'deliveryCost': PriceToJSON(value.deliveryCost),
        'isDefault': value.isDefault,
    };
}

